import * as React from 'react';
import { withMemo } from 'PyzShopUi/scripts/react/common/hoc/withMemo';
import useLanguageSelect from 'PyzShopUi/scripts/product-review/hooks/useLanguageSelect';
import NativeSelect from 'PyzShopUi/scripts/shop-ui/components/select/NativeSelect';
import {ISelectOption} from 'PyzShopUi/scripts/shop-ui/interfaces';

interface INativeLanguageSelectProps {
    label: string;
    itemLanguageOptions: ISelectOption[];
    currentItemsLanguage: string;
    dispatch: React.Dispatch<any>;
}

const NativeLanguageSelectComponent: React.FunctionComponent<INativeLanguageSelectProps> = props => {
    const { label, itemLanguageOptions, currentItemsLanguage, dispatch } = props;

    const [languageSelectOptions, onLanguageSelect] = useLanguageSelect(itemLanguageOptions, dispatch);

    return (
        <NativeSelect
            label={label}
            selectedValue={currentItemsLanguage}
            options={languageSelectOptions}
            onChange={onLanguageSelect}
        />
    );
};

const NativeLanguageSelect = withMemo(NativeLanguageSelectComponent);

export default NativeLanguageSelect;
